import { render, staticRenderFns } from "./ContactDetailForm.vue?vue&type=template&id=61952d40&scoped=true&"
import script from "./ContactDetailForm.vue?vue&type=script&lang=js&"
export * from "./ContactDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailForm.vue?vue&type=style&index=0&id=61952d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61952d40",
  null
  
)

export default component.exports